export function isBooleanTrue(errorMsg: string) {
  return (value?: boolean) => {
    return typeof value === 'boolean' && value ? errorMsg : undefined;
  };
}
